import { z } from 'zod'

export const STRATALYST_AUTH_PROFILE_SHELL_CONTRACT_VERSION = '1.0.0' as const
export const stratalystAuthProfileShellResponseSchema = z.unknown()
export type StratalystAuthProfileShellResponse = z.infer<typeof stratalystAuthProfileShellResponseSchema>
